export function Card({ children, title, icon }) {
  return (
    <div
      className="bg-amber-50/95 backdrop-blur border-4 border-amber-800 rounded-2xl shadow-2xl p-6 w-full max-w-md mx-auto animate-slideIn"
      role="region"
      aria-label={title}
    >
      {(title || icon) && (
        <div className="text-center mb-4">
          {icon && <div className="text-5xl mb-2" role="img" aria-hidden="true">{icon}</div>}
          {title && <h2 className="text-2xl font-bold text-amber-900 font-serif">{title}</h2>}
        </div>
      )}
      {children}
    </div>
  );
}
